import { render, staticRenderFns } from "./TextEditor_overall.vue?vue&type=template&id=2c24fd38&scoped=true&"
import script from "./TextEditor_overall.vue?vue&type=script&lang=js&"
export * from "./TextEditor_overall.vue?vue&type=script&lang=js&"
import style0 from "./TextEditor_overall.vue?vue&type=style&index=0&id=2c24fd38&prod&scoped=true&lang=css&"
import style1 from "./TextEditor_overall.vue?vue&type=style&index=1&id=2c24fd38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c24fd38",
  null
  
)

export default component.exports